import { useEffect, useState } from "react";
import api from "../services/api";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";

import "../styles/dashboard.css";

function Dashboard() {
  const { token } = useAuth();

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get(
          "/dashboard/stats",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setStats(response.data.stats);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token]);

  if (loading) {
    return (
      <div>
        <Navbar />
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className="dashboard-container">
        <h1>Admin Dashboard</h1>

        <div className="dashboard-grid">

          <div className="stat-card">
            <h3>Total Categories</h3>
            <p>{stats?.total_categories || 0}</p>
          </div>

          <div className="stat-card">
            <h3>Total Exams</h3>
            <p>{stats?.total_exams || 0}</p>
          </div>

          <div className="stat-card">
            <h3>Total Downloads</h3>
            <p>{stats?.total_downloads || 0}</p>
          </div>

          <div className="stat-card">
            <h3>Total Payments</h3>
            <p>{stats?.total_payments || 0}</p>
          </div>

          <div className="stat-card">
            <h3>Total Revenue</h3>
            <p>KES {stats?.total_revenue || 0}</p>
          </div>

        </div>
      </div>
    </div> 
  );
}

export default Dashboard;